import { postRaw } from './api'

export function uploadFile(file) {
  const data = new FormData();
  data.append('file', file);

  return postRaw('/files/', data)
    .then(body => body.data);
}
